import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense, Fragment, useCallback, useRef, useState, useEffect } from "react";
import { extendBlockerHeroStylesheet, extendCommonButtonsStylesheet } from "@devowl-wp/web-cookie-banner";
import { useRect } from "@reach/rect";
import { useBlocker, Portal, CloseIcon, BlockerTextContainer, useBlockerStylesheet } from "../../../..";
import { HTML_ATTRIBUTE_HERO_DIALOG_DEFAULT_OPEN } from "@devowl-wp/headless-content-unblocker";
const BlockerHeroDialog = (param)=>{
    let { blockerClassName, blockerOverlayId, heroContainerRef: ref } = param;
    const stylesheet = useBlockerStylesheet();
    const { HeroOverlay, HeroOverlayBlocker, A11ySkipToLink, screenReaderOnlyClass } = stylesheet.extend(...extendBlockerHeroStylesheet).extend(...extendCommonButtonsStylesheet);
    const blocker = useBlocker();
    const { headerDesign: { fontSize, fontColor }, i18n: { close }, blockedNode } = blocker;
    const refLastActiveElement = useRef();
    const [isDefaultBlockerVisible, setIsDefaultBlockerVisible] = useState(!!(blockedNode == null ? void 0 : blockedNode.hasAttribute(HTML_ATTRIBUTE_HERO_DIALOG_DEFAULT_OPEN)));
    const rect = useRect(ref, {
        observe: isDefaultBlockerVisible
    });
    const overlayRef = useRef();
    // Automatically close on outside click
    const handleOutsideClick = useCallback((e)=>{
        var _overlayRef_current;
        if (isDefaultBlockerVisible && [
            overlayRef.current,
            (_overlayRef_current = overlayRef.current) == null ? void 0 : _overlayRef_current.nextElementSibling
        ].indexOf(e.target) > -1) {
            setIsDefaultBlockerVisible(false);
        }
    }, [
        isDefaultBlockerVisible,
        overlayRef.current
    ]);
    const handleAcessibilityClose = (e)=>{
        var _refLastActiveElement_current;
        // Accessibility, hide hero container and focus previously selected element
        e.preventDefault();
        setIsDefaultBlockerVisible(false);
        (_refLastActiveElement_current = refLastActiveElement.current) == null ? void 0 : _refLastActiveElement_current.focus();
    };
    useEffect(()=>{
        if (ref.current) {
            const listener = (e)=>{
                refLastActiveElement.current = document.activeElement;
                const focusSkipToConsentChoices = e.target.classList.contains(screenReaderOnlyClass);
                // Save reference in data of hero container ref, so we can delegate the click for `confirm()`, see also `delegateClick()`
                if (ref.current) {
                    ref.current.consentDelegateClick = {
                        element: refLastActiveElement.current
                    };
                }
                setIsDefaultBlockerVisible(true);
                setTimeout(()=>{
                    if (focusSkipToConsentChoices) {
                        var _overlayRef_current;
                        ((_overlayRef_current = overlayRef.current) == null ? void 0 : _overlayRef_current.nextElementSibling.querySelector(`a[href^="#a"]`)).focus();
                    }
                }, 50);
                e.preventDefault();
                e.stopImmediatePropagation();
                return false;
            };
            ref.current.addEventListener("click", listener, true);
            return ()=>{
                var _ref_current;
                return (_ref_current = ref.current) == null ? void 0 : _ref_current.removeEventListener("click", listener, true);
            };
        }
        return ()=>{
        // Silence is golden.
        };
    }, [
        ref.current
    ]);
    return isDefaultBlockerVisible && rect ? /*#__PURE__*/ _jsx(Portal, {
        renderInContainer: document.body,
        children: /*#__PURE__*/ _jsxs(Fragment, {
            children: [
                /*#__PURE__*/ _jsx(HeroOverlay, {
                    ref: overlayRef,
                    onClick: handleOutsideClick
                }),
                /*#__PURE__*/ _jsxs(HeroOverlayBlocker, {
                    id: blockerOverlayId,
                    rectLeft: rect.left + window.scrollX,
                    rectTop: rect.top + window.scrollY,
                    rectWidth: rect.width,
                    className: blockerClassName,
                    onClick: handleOutsideClick,
                    "interaction-player-uqid": isDefaultBlockerVisible ? "blocker" : undefined,
                    children: [
                        /*#__PURE__*/ _jsx(A11ySkipToLink, {
                            href: "#",
                            onFocus: handleAcessibilityClose,
                            children: "\xa0"
                        }),
                        /*#__PURE__*/ _jsx(Suspense, {
                            fallback: null,
                            children: /*#__PURE__*/ _jsx(BlockerTextContainer, {
                                closeIcon: /*#__PURE__*/ _jsx(CloseIcon, {
                                    tooltipText: close,
                                    width: fontSize,
                                    color: fontColor,
                                    thickness: 2,
                                    onClick: ()=>setIsDefaultBlockerVisible(false)
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx(A11ySkipToLink, {
                            href: "#",
                            onFocus: handleAcessibilityClose,
                            children: "\xa0"
                        })
                    ]
                })
            ]
        })
    }) : null;
};
export { BlockerHeroDialog };
